import { render } from "./Operation.vue?vue&type=template&id=2e2d20c6"
import script from "./Operation.vue?vue&type=script&lang=js"
export * from "./Operation.vue?vue&type=script&lang=js"
script.render = render

export default script